module.exports = __webpack_public_path__ + "static/media/PoweredBy_Color.61c25737.svg";